import React, { Component } from "react"
import { Field, reduxForm } from "redux-form"
import { connect } from "react-redux"
import { Link } from "react-router"
import * as actions from "../../actions/event_edit"
import { DateTimePicker, DropdownList } from "react-widgets"
import Moment from "moment-timezone"
import momentLocalizer from "react-widgets/lib/localizers/moment"
Moment.tz.setDefault("Europe/London")
momentLocalizer(Moment)
import fetch from "isomorphic-fetch"
import _ from "lodash"
import { Editor, EditorState, RichUtils, ContentState } from "draft-js"

let tmpVenueList

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div
    className={`form-group ${touched && error ? "has-danger" : touched && warning ? "has-warning" : ""}`}
  >
    <label className="form-control-label">{label}</label>
    <input
      {...input}
      placeholder={label}
      type={type}
      className={`form-control ${touched && error ? "form-control-danger" : touched && warning ? "form-control-warning" : ""}`}
    />
    {touched &&
      ((error && <div className="form-text text-muted">{error}</div>) ||
        (warning && <span className="form-text text-muted">{warning}</span>))}
  </div>
)

const renderDateTimePicker = ({
  input,
  defaultValue,
  meta: { asyncValidating, touched, error }
}) => (
  <div>
    <DateTimePicker
      {...input}
      value={input.value !== "" ? new Date(input.value) : null}
      // value={
      //   input.value !== ''
      //     ? new Date(
      //         Moment(input.value).subtract(
      //           Moment(input.value).utcOffset(),
      //           'minutes',
      //         ),
      //       )
      //     : null
      // }
      onChange={(event, value) => {
        input.onChange(event)
        //console.log(event)
      }}
    />
    {touched && error && <div className="error">{error}</div>}
  </div>
)

const renderDropdownList = ({ input, defaultValue }) => (
  <DropdownList
    {...input}
    valueField="id"
    textField="name"
    data={tmpVenueList}
    value={input.value !== "" ? input.value : null}
  />
)

export class EventEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editorState: EditorState.createEmpty(),
      editorStateVideoDetails: EditorState.createEmpty()
    }

    this.onChange = editorState => this.setState({ editorState })
    this.onChangeVideoDetails = editorStateVideoDetails =>
      this.setState({ editorStateVideoDetails })
    this.onFormChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    this.props.getEventLoad()

    fetch(`${process.env.REACT_APP_EF_API_URL}/venues/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(json => {
        tmpVenueList = json.venues
        this.props.getEvent(this.props.params.id).then(event => {
          //console.log('EVENT: ' + this.props.event)
          this.handleInitialize()
          this.props.getEventLoadSuccess()
        })
      })
      .catch(error => console.error(error))
  }

  handleInitialize() {
    //const startTime = new Date(this.props.event.startTime)
    console.log("initial start time: " + this.props.event.startTime)
    let offset = Moment(new Date(this.props.event.startTime)).utcOffset()
    const startTime = Moment(new Date(this.props.event.startTime)).subtract(
      offset,
      "minutes"
    )
    //   .format()
    // moment().format();     // 2013-02-04T10:35:24-08:00
    // moment.utc().format(); // 2013-02-04T18:35:24+00:00

    // const startTimeRaw = Moment(this.props.event.startTime).format()
    // const startTime = Moment(startTimeRaw).utc().format()
    // console.log('utc start time: ' + startTime)
    // console.log(
    //   'subtracted start time format: ' +
    //     Moment(startTime).subtract(offset, 'minutes').format(),
    // )
    //const endTime = new Date(this.props.event.endTime)
    const endTime = Moment(new Date(this.props.event.endTime)).subtract(
      offset,
      "minutes"
    )
    const venueIndex = _.findIndex(tmpVenueList, [
      "_id",
      this.props.event.venue.toString()
    ])
    const event = {
      id: this.props.event._id,
      name: this.props.event.name,
      eventColor: this.props.event.eventColor,
      startTime: startTime,
      endTime: endTime,
      details: this.props.event.details,
      bookingLink: this.props.event.bookingLink,
      cost: this.props.event.cost,
      membersOnly: this.props.event.membersOnly,
      videoUrl: this.props.event.videoUrl,
      videoDetails: this.props.event.videoDetails,
      displayVideo: this.props.event.displayVideo,
      podcastUrl: this.props.event.podcastUrl,
      displayPodcast: this.props.event.displayPodcast,
      venue: tmpVenueList[venueIndex]
    }

    //console.error('event: ' +JSON.stringify(event))
    this.props.initialize(event)
    this.setState({
      event,
      editorState: EditorState.createWithContent(
        ContentState.createFromText(this.props.event.details)
      ),
      editorStateVideoDetails: EditorState.createWithContent(
        ContentState.createFromText(this.props.event.videoDetails)
      )
    })
  }

  handleFormSubmit(formProps) {
    const editorDetails = this.state.editorState
      .getCurrentContent()
      .getPlainText()
    const editorVideoDetails = this.state.editorStateVideoDetails
      .getCurrentContent()
      .getPlainText()

    let eventForm = Object.assign({}, formProps)

    eventForm.venue = eventForm.venue._id
    eventForm.details = editorDetails
    eventForm.videoDetails = editorVideoDetails

    let offset = Moment(new Date(eventForm.startTime)).utcOffset()
    const startTime = Moment(new Date(eventForm.startTime)).add(
      offset,
      "minutes"
    )
    const endTime = Moment(new Date(eventForm.endTime)).add(offset, "minutes")
    eventForm.startTime = startTime.format()
    eventForm.endTime = endTime.format()

    console.log("eventForm: " + JSON.stringify(eventForm))
    this.props.updateEvent(eventForm)
  }

  handleChange(e) {
    //console.log('Change: ' +e)
  }

  // _onBoldClick() {
  //   this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'BOLD'));
  // }

  render() {
    const { handleSubmit } = this.props

    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      // {tmpVenueList = this.props.venueList.venues}
      return (
        <div>
          <form
            onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}
            onChange={e => this.handleChange(e)}
          >
            <div
              className="btn-group float-xs-right"
              role="group"
              aria-label="Basic example"
            >
              <Link
                className="btn btn-danger"
                to={"/events/" + this.props.event._id + "/delete"}
              >
                <strong>Delete Event</strong>
              </Link>
              <button action="submit" className="btn btn-success">
                Update Event
              </button>
            </div>
            <blockquote className="blockquote">
              <h1>Edit Event</h1>
            </blockquote>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="name"
                  type="text"
                  component={renderField}
                  label="Event Name"
                />
              </fieldset>
              <fieldset className="form-group">
                <label className="radio">
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="purple"
                  />
                  {" "}
                  <span className="block purple" />
                  {" "}General events & info
                </label>
                <br />
                <label>
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="teal"
                  />
                  {" "}
                  <span className="block teal" />
                  {" "}Focus dinners, supper club, onsite visits & open events
                </label>
                <br />
                <label>
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="yellow"
                  />
                  {" "}
                  <span className="block yellow" />
                  {" "}Annual conferences & award dinners
                </label>
                <br />
                <label>
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="red"
                  />
                  {" "}
                  <span className="block red" />
                  {" "}Exchange programme
                </label>
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="startTime"
                  component={renderDateTimePicker}
                  hintText="Event Start Time"
                  autoOk={true}
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="endTime"
                  component={renderDateTimePicker}
                  hintText="Event End Time"
                  autoOk={true}
                />
              </fieldset>
              <fieldset className="form-group">
                <label>Event Details</label>
                <Editor
                  editorState={this.state.editorState}
                  onChange={this.onChange}
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="bookingLink"
                  type="text"
                  component={renderField}
                  label="Event Booking Link"
                />
              </fieldset>
            </div>

            <div className="alert alert-success">Membership & Cost</div>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="cost"
                  type="text"
                  component={renderField}
                  label="Event Cost"
                />
              </fieldset>
              <fieldset className="form-group">
                <label>Members only?&nbsp;</label>
                <Field
                  name="membersOnly"
                  id="membersOnly"
                  component="input"
                  type="checkbox"
                />
              </fieldset>
            </div>

            <div className="alert alert-success">Event Video</div>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="videoUrl"
                  type="text"
                  component={renderField}
                  label="Event Video URL"
                />
              </fieldset>
              <fieldset className="form-group">
                <label className="form-control-label">Video Details</label>
                <Editor
                  editorState={this.state.editorStateVideoDetails}
                  onChange={this.onChangeVideoDetails}
                />
              </fieldset>
              <fieldset className="form-group">
                <label>Display video in mobile app?&nbsp;</label>
                <Field
                  name="displayVideo"
                  id="displayVideo"
                  component="input"
                  type="checkbox"
                />
              </fieldset>
            </div>

            <div className="alert alert-success">Event Podcast</div>
            <div className="well">
              <fieldset classname="form-group">
                <Field
                  name="podcastUrl"
                  type="text"
                  component={renderField}
                  label="Event Podcast URL"
                />
              </fieldset>
              <fieldset classname="form-group">
                <label>Display podcast in mobile app?&nbsp;</label>
                <Field
                  name="displayPodcast"
                  id="displayPodcast"
                  component="input"
                  type="checkbox"
                />
              </fieldset>
            </div>

            <div className="alert alert-success">Venue</div>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="venue"
                  component={renderDropdownList}
                  label="Event Venue"
                />
              </fieldset>
            </div>
          </form>

        </div>
      )
    }
  }
}

function validate(formProps) {
  const errors = {}

  if (formProps.name === "") {
    errors.name = "Please enter an event name"
  }

  if (formProps.startTime === "") {
    errors.startTime = "Event must have a start time"
  }

  if (formProps.endTime === "") {
    errors.endTime = "Event must have an end time"
  }

  if (formProps.cost === "") {
    errors.cost = "Event must have a cost or be specified as free"
  }

  return errors
}

function warn(formProps) {
  const warnings = {}

  if (formProps.bookingLink === "") {
    warnings.bookingLink =
      "You can leave this blank but customers won't be able book this event"
  }
  return warnings
}

const form = reduxForm({
  form: "eventedit",
  validate,
  warn
})

function mapStateToProps(state) {
  //console.error('state: ' +JSON.stringify(state))
  return {
    event: state.event.item,
    loading: state.event.loading
  }
}

export default connect(mapStateToProps, actions)(form(EventEdit))



/** WEBPACK FOOTER **
 ** ./src/components/events/edit.js
 **/